export default "__VITE_ASSET__fb294ad5__"